import { Avatar, DefaultImage } from '@assets/images'
import { enUS } from 'date-fns/locale'

const imageValidationExtensions = [
  'png',
  'jpg',
  'jpeg',
  'gif',
  'svg',
  'heic',
  'heif',
  'webp',
]

const videoValidationConfig = {
  videoValidationExtensions: ['mp4', 'mkv', 'avi', 'mov', 'wmv', 'flv'],
  maxVideoSize: 50,
  maxVideoDuration: 300,
}

const defaultUser = Avatar
const defaultNoImage = DefaultImage

const orderStatus = ['Pending', 'Driver Assigned', 'Delivered', 'Returned']
const driverStatus = ['Available', 'Reserved', 'Unavailable']

const shortLocale = {
  ...enUS,
  formatDistance: (token: string, count: number) => {
    const format: Record<string, string> = {
      xSeconds: `${count}s ago`,
      xMinutes: `${count}m ago`,
      xHours: `${count}h ago`,
      xDays: `${count}d ago`,
      xMonths: `${count}mo ago`,
      xYears: `${count}y ago`,
    }
    return format[token] || `${count} ${token}`
  },
}
export default {
  imageValidationExtensions,
  videoValidationConfig,
  defaultUser,
  defaultNoImage,
  driverStatus,
  orderStatus,
  shortLocale,
}
